// extracted by mini-css-extract-plugin
export var cardContainer = "_o1-0";
export var cardHeader = "_o1-2";
export var collapsedState = "_o1-3";
export var dragHandle = "_o1-5";
export var dragHandleIcon = "_o1-6";
export var dragging = "_o1-1";
export var titleArea = "_o1-4";